module.exports = __webpack_public_path__ + "img/bn_get.f266288.png";